// Lightning is a safety signal. A timer reset in the app must show on the board within
// seconds, not at the next full widget refresh. Matches widget-v2 and the pw3 dashboard
// (HER-288): poll lightning every 15s while the page is visible; keep everything else on
// the classic 5 minutes. Budget while visible: 4 lightning reads/min per board. The
// LightningDelay endpoint resolves the widget then reads Redis TTL — cheap enough at this
// rate for always-on displays, which is why background tabs skip the interval entirely.
export const LIGHTNING_REFRESH_MS = 15000;
export const WIDGET_REFRESH_MS = 300000;
// Local countdown ticks every second; server TTL is whole seconds and can lag the tick by
// about one second. Ignore that noise so the board does not jump 19:44 → 19:45 every poll.
// Still apply clear↔active flips and real resets (e.g. 19 min → 29 min).
export const LIGHTNING_DRIFT_TOLERANCE_SECONDS = 2;
// After a good read, keep the last good UI through failed polls. Only surface Unavailable
// once the board has been flying blind as long as a full widget refresh (5 minutes).
export const LIGHTNING_STALE_MS = WIDGET_REFRESH_MS;
export function shouldPollLightning(widgetId, visibilityState) {
    return Boolean(widgetId) && widgetId !== "builder" && visibilityState === "visible";
}
export function shouldApplyServerDelay(localSeconds, serverSeconds, toleranceSeconds = LIGHTNING_DRIFT_TOLERANCE_SECONDS) {
    const localActive = localSeconds > 0;
    const serverActive = serverSeconds > 0;
    if (localActive !== serverActive)
        return true;
    return Math.abs(serverSeconds - localSeconds) > toleranceSeconds;
}
// Smooth local tick under the last successful read. Never invents Clear: holds the last
// active second until a successful poll sets 0 (or a new delay).
export function tickLightningDelay(localSeconds) {
    if (localSeconds <= 0)
        return 0;
    if (localSeconds <= 1)
        return 1;
    return localSeconds - 1;
}
// Unavailable only with no successful read yet, or after flying blind past the stale budget.
export function shouldShowLightningError(hasSuccessfulRead, msSinceSuccessfulRead, staleMs = LIGHTNING_STALE_MS) {
    if (!hasSuccessfulRead)
        return true;
    return msSinceSuccessfulRead >= staleMs;
}
// Number(null) is 0 in JS — that would paint a false Clear. Only a real finite number counts.
export function parseLightningDelaySeconds(raw) {
    if (typeof raw !== "number" || !Number.isFinite(raw))
        return null;
    return raw;
}
